/* ============================================
   THE SHIRE STUDIO — Main JS
   ============================================ */

/* ---- CART BUTTON — inject into StaggeredMenu header ---- */
(function () {
  const BAG_SVG = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 01-8 0"/></svg>`;

  const inject = (header) => {
    if (header.querySelector('.sm-cart-btn')) return;

    const drawer = document.getElementById('ShireCartDrawer');
    const n = parseInt(drawer?.dataset.initialCount || '0', 10);

    const btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'sm-cart-btn';
    btn.setAttribute('aria-label', 'Apri carrello');
    btn.innerHTML =
      BAG_SVG +
      `<span class="sm-cart-count"${n < 1 ? ' hidden' : ''}>${n || ''}</span>`;

    btn.addEventListener('click', () => {
      document.dispatchEvent(new CustomEvent('shire:openCart'));
    });

    /* global updater called by cart drawer render() */
    window.shireUpdateCartCount = (count) => {
      const badge = document.querySelector('.sm-cart-count');
      if (!badge) return;
      badge.textContent = count || '';
      count > 0 ? badge.removeAttribute('hidden') : badge.setAttribute('hidden', '');
    };

    /* wrap existing toggle + new cart btn in a flex group */
    const toggle = header.querySelector('.sm-toggle');
    if (toggle) {
      const group = document.createElement('div');
      group.className = 'sm-actions-group';
      header.removeChild(toggle);
      group.appendChild(toggle);
      group.appendChild(btn);
      header.appendChild(group);
    } else {
      header.appendChild(btn);
    }
  };

  const watchMenu = () => {
    const h = document.querySelector('.staggered-menu-header');
    if (h) { inject(h); return; }
    const obs = new MutationObserver(() => {
      const h2 = document.querySelector('.staggered-menu-header');
      if (h2) { obs.disconnect(); inject(h2); }
    });
    const root = document.getElementById('shire-menu-root') || document.body;
    obs.observe(root, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watchMenu);
  } else {
    watchMenu();
  }
})();

document.addEventListener('DOMContentLoaded', function () {

  // ---- HEADER: cambia background allo scroll ----
  const header = document.getElementById('ShireHeader');
  if (header) {
    window.addEventListener('scroll', function () {
      if (window.scrollY > 60) {
        header.style.backgroundColor = 'rgba(245,242,238,0.95)';
        header.style.backdropFilter = 'blur(8px)';
        header.style.mixBlendMode = 'normal';
      } else {
        header.style.backgroundColor = 'transparent';
        header.style.backdropFilter = 'none';
        header.style.mixBlendMode = 'multiply';
      }
    });
  }

  // ---- MARQUEE: pausa on hover ----
  const marqueeTrack = document.querySelector('.shire-marquee__track');
  if (marqueeTrack) {
    marqueeTrack.addEventListener('mouseenter', function () {
      marqueeTrack.style.animationPlayState = 'paused';
    });
    marqueeTrack.addEventListener('mouseleave', function () {
      marqueeTrack.style.animationPlayState = 'running';
    });
  }

  // ---- PRODUCT ITEMS: hover con freccia animata ----
  document.querySelectorAll('.shire-product-item').forEach(function (item) {
    item.addEventListener('mouseenter', function () {
      const arrow = item.querySelector('span');
      if (arrow) arrow.style.transform = 'translateX(8px)';
    });
    item.addEventListener('mouseleave', function () {
      const arrow = item.querySelector('span');
      if (arrow) arrow.style.transform = 'translateX(0)';
    });
  });

  // Transizione freccia smooth
  document.querySelectorAll('.shire-product-item span').forEach(function (span) {
    span.style.display = 'inline-block';
    span.style.transition = 'transform 0.3s ease';
  });

});
